/**
 * Gets a cookie value by name
 */
export const getCookie = (name: string): string | null => {
  const cookies = document.cookie.split(';');

  for (const cookie of cookies) {
    const trimmed = cookie.trim();
    const eqIndex = trimmed.indexOf('=');

    if (eqIndex !== -1) {
      const cookieName = trimmed.substring(0, eqIndex);
      const cookieValue = trimmed.substring(eqIndex + 1);

      if (cookieName === name) {
        return decodeURIComponent(cookieValue);
      }
    }
  }

  return null;
};

/**
 * Deletes a cookie by name
 */
export const deleteCookie = (name: string): void => {
  document.cookie = `${name}=; expires=${new Date(0).toUTCString()}; path=/;`;
};

interface PollForCookieOptions {
  cookieName: string;
  expectedValue: string;
  intervalMs?: number;
  timeoutMs?: number;
}

/**
 * Polls for a cookie with a specific value.
 * Resolves when the cookie is found, rejects on timeout.
 */
export const pollForDownloadCookie = ({
  cookieName,
  expectedValue,
  intervalMs = 500,
  timeoutMs = 90000,
}: PollForCookieOptions): Promise<void> =>
  new Promise((resolve, reject) => {
    const startTime = Date.now();

    const checkCookie = () => {
      const cookieValue = getCookie(cookieName);

      if (cookieValue === expectedValue) {
        deleteCookie(cookieName);
        resolve();
        return;
      }

      if (Date.now() - startTime >= timeoutMs) {
        reject(new Error('Download cookie polling timed out'));
        return;
      }

      setTimeout(checkCookie, intervalMs);
    };

    checkCookie();
  });
